import React, { useState } from "react";
import axios from "axios";
import styles from "./AddMember.module.css";

export default function AddMember({ onClose, onSaved }: any) {
  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";
  const token = localStorage.getItem("bni_token");

  const RECOGNITION_OPTIONS = [
    "Crorepati Giver",
    "Green Pin",
    "Gold Pin",
    "Leadership Pin",
  ];

  const [form, setForm] = useState<any>({
    name: "",
    email: "",
    contactNo: "",
    whatsappNo: "",
    orgName: "",
    orgBio: "",
    website: "",
    socialHandles: {
      facebook: "",
      linkedin: "",
      instagram: "",
    },
    bio: "",
    companyDetails: "",
    address: "",
    businessCategory: "",
    recognition: [],
    memberType: "Member",

    // ✅ Instead of image upload → simple string input
    userImage: "",
    companyLogo: "",
  });

  const [loading, setLoading] = useState(false);

  const update = (key: string, value: any) =>
    setForm({ ...form, [key]: value });

  const updateSocial = (key: string, value: any) =>
    setForm({
      ...form,
      socialHandles: { ...form.socialHandles, [key]: value },
    });

  const toggleRecognition = (item: any) => {
    const updated = form?.recognition?.includes(item)
      ? form.recognition.filter((x: any) => x !== item)
      : [...form.recognition, item];

    setForm({ ...form, recognition: updated });
  };

  const submit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/api/members`, form, {
        headers: { Authorization: "Bearer " + token },
      });

      alert("✅ Member added successfully!");
      onSaved && onSaved();
    } catch (err: any) {
      alert(err.response?.data?.message || "Failed to add member");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.addWrapper}>
      <h2 className={styles.addHeading}>Add New Member</h2>

      <form onSubmit={submit} className={styles.addCard}>
        {/* LEFT PANEL */}
        <div className={styles.sidePanel}>
          {/* ✅ Profile Image Path */}
          <div className={styles.photoBox}>
            <img
              src={
                form.userImage
                  ? form.userImage.startsWith("http")
                    ? form.userImage
                    : API + form.userImage
                  : "/images/profile-placeholder.png"
              }
              alt="Profile"
              className={styles.mainPhoto}
            />
            <div className={styles.inputGroup}>
              <label>Profile Image Path</label>
              <input
                value={form.userImage}
                placeholder="/uploads/members/photo.png"
                onChange={(e) => update("userImage", e.target.value)}
              />
            </div>
          </div>

          {/* ✅ Company Logo Path */}
          <div className={styles.logoBox}>
            <img
              src={
                form.companyLogo
                  ? form.companyLogo.startsWith("http")
                    ? form.companyLogo
                    : API + form.companyLogo
                  : "/images/company-placeholder.png"
              }
              alt="Company Logo"
              className={styles.logoPreview}
            />
            <div className={styles.inputGroup}>
              <label>Company Logo Path</label>
              <input
                value={form.companyLogo}
                placeholder="/uploads/members/logo.png"
                onChange={(e) => update("companyLogo", e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className={styles.formPanel}>
          {/* BASIC */}
          <div className={styles.formSection}>
            <h3 className={styles.sectionHeader}>Basic Details</h3>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <label>Name *</label>
                <input
                  required
                  value={form.name}
                  onChange={(e) => update("name", e.target.value)}
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Email</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => update("email", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <label>Contact No.</label>
                <input
                  value={form.contactNo}
                  onChange={(e) => update("contactNo", e.target.value)}
                />
              </div>

              <div className={styles.inputGroup}>
                <label>WhatsApp No.</label>
                <input
                  value={form.whatsappNo}
                  onChange={(e) => update("whatsappNo", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label>Address</label>
              <input
                value={form.address}
                onChange={(e) => update("address", e.target.value)}
              />
            </div>
          </div>

          {/* BUSINESS */}
          <div className={styles.formSection}>
            <h3 className={styles.sectionHeader}>Business Information</h3>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <label>Organisation Name</label>
                <input
                  value={form.orgName}
                  onChange={(e) => update("orgName", e.target.value)}
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Business Category</label>
                <input
                  value={form.businessCategory}
                  onChange={(e) => update("businessCategory", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label>Website</label>
              <input
                value={form.website}
                onChange={(e) => update("website", e.target.value)}
              />
            </div>

            <div className={styles.inputGroup}>
              <label>Company Details</label>
              <textarea
                rows={3}
                value={form.companyDetails}
                onChange={(e) => update("companyDetails", e.target.value)}
              />
            </div>

            <div className={styles.inputGroup}>
              <label>Organisation Bio</label>
              <textarea
                rows={3}
                value={form.orgBio}
                onChange={(e) => update("orgBio", e.target.value)}
              />
            </div>
          </div>

          {/* SOCIAL */}
          <div className={styles.formSection}>
            <h3 className={styles.sectionHeader}>Social Links</h3>

            <div className={styles.row}>
              <div className={styles.inputGroup}>
                <label>Facebook</label>
                <input
                  value={form.socialHandles.facebook}
                  onChange={(e) => updateSocial("facebook", e.target.value)}
                />
              </div>

              <div className={styles.inputGroup}>
                <label>Instagram</label>
                <input
                  value={form.socialHandles.instagram}
                  onChange={(e) => updateSocial("instagram", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label>LinkedIn</label>
              <input
                value={form.socialHandles.linkedin}
                onChange={(e) => updateSocial("linkedin", e.target.value)}
              />
            </div>
          </div>

          {/* BIO */}
          <div className={styles.formSection}>
            <h3 className={styles.sectionHeader}>Bio</h3>
            <textarea
              rows={3}
              value={form.bio}
              onChange={(e) => update("bio", e.target.value)}
            />
          </div>

          {/* BNI INFO */}
          <div className={styles.formSection}>
            <h3 className={styles.sectionHeader}>BNI Information</h3>

            <div className={styles.inputGroup}>
              <label>Role</label>
              <select
                value={form.memberType}
                onChange={(e) => update("memberType", e.target.value)}
              >
                <option value="President">President</option>
                <option value="Vice President">Vice President</option>
                <option value="Secretary Treasurer">Secretary Treasurer</option>
                <option value="Lead Visitor Host">Lead Visitor Host</option>
                <option value="Member">Member</option>
              </select>
            </div>

            {/* ✅ MULTIPLE Recognition */}
            <div className={styles.inputGroup}>
              <label>Recognition</label>

              <div className={styles.badgeContainer}>
                {RECOGNITION_OPTIONS.map((item) => (
                  <label key={item} className={styles.badgeCheck}>
                    <input
                      type="checkbox"
                      checked={form.recognition.includes(item)}
                      onChange={() => toggleRecognition(item)}
                    />
                    <span>{item}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* ACTIONS */}
          <div className={styles.actionsRow}>
            <button className={styles.saveBtn} disabled={loading}>
              {loading ? "Saving..." : "✅ Add Member"}
            </button>

            <button
              type="button"
              className={styles.cancelBtn}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
